<template>
    <b-row>
        <b-col>
            <div class="row justify-content-between align-items-center col-12 mb-2">
                <TitleComponent title="Rellena los datos" subtitle="Rellena la siguiente información para continuar:"/>
                <Button @click="$emit('cambiarParcelas')">Cambiar Parcelas</Button>
            </div>
        </b-col>
        <b-col cols="12" class="mt-3">
            <transition name="fade" mode="out-in">
                <FormDatosParcelas 
                    :datosParcelas="datosParcelas"
                    :cart_id="cart_id"
                    @finalizarPasoTres="finalizarPasoTres"
                />  
            </transition>
        </b-col>
    </b-row>
</template>

<script>
    import FormDatosParcelas from '@/components/backend/parcelas/FormDatosParcelas';
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    export default {
        props: {
            datosParcelas: {
                type: Array,
                required: true
            },
            cart_id: {
                type: Number,
                required: true
            }
        },
        methods: {
            finalizarPasoTres(datosParcelas, pago) {
                datosParcelas.metodo_pago = pago;
                this.$emit('terminado', datosParcelas);
            }
        },
        components: {
            FormDatosParcelas,
            TitleComponent
        }
    }
</script>